import React from "react";
import { useI18n } from "@/i18n";
import { useCategories } from "@/lib/categories";

/** Catalogue tabs from the categories managed in the admin. */
export function CategoryChips({ value, onChange }: { value?: string; onChange: (category?: string) => void }) {
  const { t } = useI18n();
  const categories = useCategories();
  return (
    <div className="category-tabs">
      <button data-active={!value} onClick={() => onChange(undefined)}>
        {t("catalog.all")}
      </button>
      {(categories ?? []).map((c) => (
        <button key={c.id} data-active={value === c.slug} onClick={() => onChange(c.slug)}>
          {c.name}
        </button>
      ))}
    </div>
  );
}
